import { axios, handleError } from '../axios';

export const trashStats = () => {
  return new Promise((resolve) => {
    axios
      .get('admin/trash/stats/', {})
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
